<template>
  <div class="">
    <div class="row justify-content-center py-5 einblenden1">
      <div class="col-lg-10 grauHintergrund">
        <!-- Klebebänder-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildZubehoer/Klebebaender.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                <h2 class="kachelHeader">Klebebänder</h2>
                Unsere individuell bedruckbaren Klebebänder vereinen zuverlässige
                Verschlusstechnik mit aufmerksamkeitsstarkem Branding. Ob Logo, Slogan
                oder Warnhinweis – gestalten Sie Ihr Klebeband ganz nach Wunsch und sorgen
                Sie so für einen professionellen Auftritt ab dem ersten Handgriff. Die
                Bänder sind in vielen Farben erhältlich, haften stark auf
                unterschiedlichsten Oberflächen und eignen sich ideal für Versand, Lager
                und Werbung. Ein praktisches Verpackungsmittel, das gleichzeitig als
                wirkungsvolle Kommunikationsfläche dient.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Rollenmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kblaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kbbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in my:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="kbhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="kbText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="handfolie" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addKb()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedKb" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Bündel- Umreifungsband-->
        <div class="row p-2 m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildZubehoer/Umreifungsband.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <h2 class="kachelHeader">Bündel- Umreifungsband</h2>
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                Unser Bündel- und Umreifungsband bietet eine zuverlässige Lösung zur
                Sicherung, Fixierung und Bündelung verschiedenster Produkte. Es ist
                äußerst reißfest, widerstandsfähig und lässt sich sowohl manuell als auch
                maschinell einfach verarbeiten. Ideal für Paletten, Kartons oder sperrige
                Güter sorgt das Band für stabilen Halt beim Transport und in der Lagerung.
                Je nach Bedarf ist es in verschiedenen Materialien wie PP, PET oder Textil
                erhältlich – für maximale Sicherheit bei jedem Einsatz.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Rollenmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="ublaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="ubbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in mm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="ubhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="ubText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="umreifband" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addUb()"
                style="z-index: 2; position: relative"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedUb" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>

        <!-- Stahlband-->
        <div class="row p-2m-md-4 m-1 hellgrauHintergrund">
          <div class="col-lg-2">
            <img
              src="../assets/balkenMitBildZubehoer/Stahlband.png"
              alt="ltb-logo"
              class="img-fluid bildschatten"
            />
          </div>
          <div class="col-lg-7 text-start">
            <div class="row">
              <div class="col-lg-8 Artikeltext">
                <h2 class="kachelHeader">Stahlband</h2>
                Unser Stahlband ist die ideale Lösung für höchste Anforderungen in der
                Umreifung schwerer und scharfkantiger Güter. Es überzeugt durch maximale
                Zugfestigkeit, Formstabilität und Widerstandsfähigkeit – selbst unter
                extremen Bedingungen. Besonders in der Metall-, Holz- oder Bauindustrie
                sorgt das Stahlband für eine sichere Fixierung und zuverlässige
                Ladungssicherung bei Transport und Lagerung. Es ist in verschiedenen
                Breiten, Stärken und Oberflächenveredelungen erhältlich und eignet sich
                für den manuellen sowie maschinellen Einsatz.
              </div>
              <div class="col-lg-4">
                <span class="kachelText">
                  Rollenmaße:
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Länge in Meter:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="sblaenge"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Breite in cm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="sbbreite"
                    />
                  </div>
                  <div class="input-group input-group-sm mb-1">
                    <span class="input-group-text masseText" id="basic-addon1"
                      >Stärke in mm:</span
                    >
                    <input
                      type="number"
                      class="form-control masseFeld"
                      v-model="sbhoehe"
                    />
                  </div>
                  <span class="input-group-text" style="width: 100%" id="basic-addon1"
                    >Kurze Beschreibung</span
                  >
                  <div class="input-group mb-3">
                    <textarea
                      class="form-control"
                      aria-label="With textarea"
                      v-model="sbText"
                    ></textarea>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3 text-start">
            <p class="kachelHeader">Anfrage</p>
            <div class="input-group mb-3">
              <span class="input-group-text anzahlText" id="basic-addon1">Anzahl</span>
              <input type="number" class="form-control anzahlFeld" v-model="stahlband" />
              <button
                class="btn btn-outline-secondary"
                type="button"
                id="button-addon2"
                @click="addSb()"
              >
                Hinzufügen
              </button>
            </div>
            <!-- ✔️ Feedback-Text -->
            <div v-if="addedSb" class="text-success mt-2 small fade-in-out">
              Zum Angebot hinzugefügt
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { anfragenStore } from "@/stores/AnfrageStore";
export default {
  name: "balkenMitBildPaletten",
  data() {
    return {
      kblaenge: 0,
      kbbreite: 0,
      kbhoehe: 0,
      kbText: "",
      klebeband: 0,
      umreifband: 0,
      ublaenge: 0,
      ubbreite: 0,
      ubhoehe: 0,
      ubText: "",
      stahlband: 0,
      sblaenge: 0,
      sbbreite: 0,
      sbhoehe: 0,
      sbText: "",
      addedKb: false,
      addedUb: false,
      addedSb: false,
    };
  },

  methods: {
    addKb() {
      let item = {
        name: "Klebeband",
        anzahl: this.klebeband,
        beschreibung: this.kbText,
        masse: {
          meter: this.kblaenge,
          breite: this.kbbreite,
          staerkemy: this.kbhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedKb = true;
      setTimeout(() => {
        this.addedKb = false;
      }, 5000);
    },
    addUb() {
      let item = {
        name: "Umreifungsband",
        anzahl: this.umreifband,
        beschreibung: this.ubText,
        masse: {
          meter: this.ublaenge,
          breite: this.ubbreite,
          staerkemm: this.ubhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedUb = true;
      setTimeout(() => {
        this.addedUb = false;
      }, 5000);
    },
    addSb() {
      let item = {
        name: "Stahlband",
        anzahl: this.stahlband,
        beschreibung: this.sbText,
        masse: {
          meter: this.sblaenge,
          breite: this.sbbreite,
          staerkemm: this.sbhoehe,
        },
      };
      const store = anfragenStore();
      store.addItem(item);
      // ✅ Feedback anzeigen
      this.addedSb = true;
      setTimeout(() => {
        this.addedSb = false;
      }, 5000);
    },
  },
};
</script>
